<template>
  <div class="openclass-live">



    <div class="live-content">
      <div class="live-banner-bgc">
        <div class="class-live-banner maxW clear">
          <div class="fl live-banner-tit">
            <i class="ipng Shape_07" @click="goback()"></i>
            <strong>{{ videoName }}</strong>
            <i style="margin-left:1rem" title="观看记录中" v-if="view" class="el-icon-view"></i>
          </div>

          <div class="live-banner-r fr clear">
            <div class="train-file-l-share box fr">
              <div class="copyright-container" @click="handleClickCopyright">
                <span class="copyright-text">版权声明</span>
                <i class="el-icon-info"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="video-play-cont maxW">
          <div class="video-box">

            <DPlayer ref="dplayer" v-if="videoFlag" :showTest="!modelType && !courseData.sources_id" :options="courseData"
              :videoStatus="1" :pointData="pointData" @pause="handlePause" @play="handlePlay" @end="handleEnd"
              @getVideoCountTime="countTime()" @notCountTime="notCountTime()"></DPlayer>
          </div>

          <section class="video-count">
            <div>
              <div>
                <img src="@/assets/images/customer/see.png" alt="">
                <div>{{ courseData.clicks ? courseData.clicks : 0 }}{{ $t('customer.unit1') }}</div>
              </div>
              <!-- <div>
                <img class="adjust" src="@/assets/images/v2/download.png" alt="">
                <div>{{ courseData.downloads ? courseData.downloads : 0 }}{{ $t('customer.unit1') }}</div>
              </div> -->
              <div>
                <img class="adjust" src="@/assets/images/customer/pinglun.png" alt="">
                <div>{{ courseData.comments ? courseData.comments : 0 }}{{ $t('customer.unit2') }}</div>
              </div>
            </div>

            <div class="live-banner-r fr clear">
              <div class="train-file-l-share box fr">
                <!-- <el-button class="share-btn fr" @click="share"><img src="../../../assets/images/share_icon.png" />{{
                  $t("homepage.shareLink")
                }}</el-button> -->
                <sharePC :share.sync="shareLink" />
              </div>
            </div>
          </section>
        </div>

      </div>


      <div class="live-commont maxW clear">
        <div class="live-commont-l fl">
          <template>
            <section class="video-info">
              <div class="info-left">
                <el-tabs type="border-card">
                  <el-tab-pane label="考题测试" v-if="courseData.task_test_id">
                    <div style="
                        display: flex;
                        justify-content: space-between;
                        align-items: start;
                        height: 248px;
                      ">
                      <div style="display: flex">
                        <img style="display: block; width: 50px; height: 60px"
                          src="../../../assets/images/v2/test_icon.png" />
                        <div style="padding-left: 50px">
                          <p style="font-size: 16px; font-weight: bold">
                            考题测试
                          </p>
                          <p class="test-status" style="margin-top: 25px; font-size: 14px">
                            <i v-if="videoInfo.test_complete_status" class="el-icon-success"
                              :style="{ color: '#67C23A' }" style="padding-right: 5px">
                            </i>

                            <span v-else class="test-icon"></span>

                            {{
                              videoInfo.test_complete_status
                                ? $t("homepage.testStatus")
                                : $t("homepage.hasComplete")
                            }}

                            <span style="margin-left: 10px; color: green" v-if="videoInfo.test_complete_status">{{
                              videoInfo.test_complete_score }}</span>
                          </p>
                        </div>
                      </div>
                      <div style="display: flex; align-items: center">
                        <i style="font-size: 20px; margin-right: 15px" class="el-icon-refresh" v-if="!testLoading"
                          @click="handRefreshTest"></i>
                        <i style="font-size: 20px; margin-right: 15px" class="el-icon-loading" v-else></i>
                        <el-button type="danger" @click="goTest(0)" plain>进入测试</el-button>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('homepage.classIntr')">
                    <div class="intr-item" v-for="(item, index) in intrArr" :key="index"
                      :class="{ 'hidden-item': !(item.content || item.label === $t('homepage.videoIntr')) }">
                      <template v-if="item.content || item.label === $t('homepage.videoIntr')">
                        <div class="item-label">{{ item.label }}</div>
                        <div class="item-content" v-if="item.content && item.content.includes('</')"
                          v-html="item.content">
                        </div>
                        <div class="item-content" v-else>{{ item.content ? item.content : $t("global.noData") }}</div>
                      </template>

                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('homepage.comment')">
                    <Review @refresh="getIntroduction" @changeCount="changeCount" :videoData="courseData" />
                  </el-tab-pane>

                </el-tabs>
              </div>
              <div class="info-right" v-if="false">
                <header>
                  <img src="@/assets/images/customer/download.png" alt="download">
                  {{ $t('homepage.downloadRes') }}
                </header>
                <div class="file-content">
                  <div class="content-placeholder" v-if="fileArr.length === 0">{{ $t('customer.noData') }}</div>
                  <div class="file-item" v-for="item in fileArr" :key="item.res_id" @click="downloadFile(item.id)">
                    <div class="item-name">{{ item.name }}</div>
                    <div class="item-download"><i class="el-icon-download"></i></div>
                  </div>
                </div>
              </div>
            </section>
          </template>
        </div>
        <div class="live-commont-r fr">
          <div class="i_reviewArea_pd">
            <div class="i_dataDownload_t">
              <img src="@/assets/images/v2/ziliaoxiazai.png" style="width: 30px;height: 30px;margin:5px 5px 0 0">
              <span>{{ $t("homepage.downloadRes") }}</span>
            </div>
            <div class="i_dataDownload_c">
              <ul id="video_file" v-if="!courseData.sources_id && !modelType">
                <li class="dataFile clear" v-for="(item, index) of videoFileData" :key="index">
                  <a href="javascript:;">{{
                    item.name.split(".")[1]
                    ? item.name
                    : item.name + "." + item.attachemnt_path.split(".")[1]
                  }}</a>
                  <!-- <a href="javascript:;">{{ item.name }}.{{ item.postfix }}</a> -->
                  <i class="ipng but_doland02_slide" @click="down(item)"></i>
                </li>
              </ul>
              <div class="dataFileBG" v-if="false">
                <span>- {{ $t("global.noData") }} -</span>
              </div>
              <div class="pageBox">
                <el-pagination small background v-if="total_number1 > page_size1"
                  @current-change="change_page(page_index1, '1')" :page-size="page_size1" :current-page.sync="page_index1"
                  layout="prev, pager, next" :total="total_number1"></el-pagination>
              </div>
            </div>
          </div>
          <div class="i_reviewArea_pd">
            <div class="i_dataDownload_t">
              <img src="@/assets/images/v2/zuji.png" style="width: 30px;height: 30px;margin:5px 5px 0 0">
              <span>{{ $t("homepage.watched") }}</span>
            </div>
            <div class="i_dataDownload_c">
              <div class="dataUser clear" id="video_record">
                <el-popover placement="top" trigger="hover" v-for="(item, index) of sawPeopleData" :key="index">
                  <div class="i_userIn">
                    <div class="i_userIn_txt clear">
                      <img class="avatar-pic fl" :src="item.avatar_path" />
                      <div class="saw-people-info">
                        <span>{{ item.username }}</span>
                        <span>{{ item.message[0].org_name }}</span>
                        <span>{{ item.message[0].company_position_name }}</span>
                      </div>
                    </div>
                  </div>
                  <el-button class="saw-btn" type="text" slot="reference">
                    <a href="javascript:;">
                      <img class="r-avatar-img" :src="item.avatar_path" />
                    </a>
                  </el-button>
                </el-popover>
              </div>
              <div class="dataFileBG2" v-if="sawPeopleData.length == 0">
                <p>- {{ $t("global.noData") }} -</p>
              </div>
              <div class="pageBox">
                <el-pagination small background v-if="total_number2 > page_size2"
                  @current-change="change_page(page_index2, '2')" :page-size="page_size2" :current-page.sync="page_index2"
                  layout="prev, pager, next" :total="total_number2"></el-pagination>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 截图功能相关： -->
    <canvas id="myCanvas" width="1200" height="672"
      style="display: none; border: 1px solid #d3d3d3; background: #ffffff"></canvas>
    <template>
      <uploader style="display: none" :options="uploadOptions" :autoStart="false" ref="uploader"
        :file-status-text="statusText" @file-success="fileSuccess" @file-error="fileFail" class="shot-uploader">
      </uploader>
    </template>

    <el-dialog :title="$t('homepage.shareLink')" class="share_dialog" :visible.sync="showShare" width="550px">
      <p class="share_text">{{ $t("global.copyUrlmessage") }}</p>
      <p class="share_text">
        <el-radio-group v-model="changeCopy" @change="getCopyVal">
          <el-radio :label="1">{{ $t("global.webUrl") }}</el-radio>
          <el-radio :label="2">{{ $t("global.H5Url") }}</el-radio>
        </el-radio-group>
      </p>
      <p class="share_link">
        {{ $t("global.linkUrl") }}：<a style="color: deepskyblue" href="#">{{
          shareLink
        }}</a>
      </p>

      <div class="qrcode_container" id="qrcode" ref="qrcode" v-if="changeCopy === 2"></div>

      <el-button class="copy_btn" type="primary" @click="copyShareLink">{{
        $t("global.copy")
      }}</el-button>
    </el-dialog>

    <el-dialog :title="$t('global.warningTitle')" class="share_dialog" :visible.sync="isRead" width="550px" top="30vh"
      :close-on-click-modal="false" :show-close="false">
      <div style="line-height:1.4rem;height:4rem;font-size: 1.1rem;">{{ $t('global.warning') }}</div>
      <el-button class="copy_btn" type="primary" @click="isRead = false">{{
        $t("global.sure")
      }}</el-button>
    </el-dialog>

    <el-dialog title="" id="viewImageFlag" :visible.sync="viewImageFlag" style="padding: 0; margin: 0" width="750px">
      <img style="width: 750px; height: 420px" :src="imgUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
// import "videojs-flash";
// import "../../../assets/js/zh-CN";
// import classTest from "./class-test";
import axios from "axios";
import "html2canvas";
import QRCode from 'qrcodejs2'
import DPlayer from "../../../components/common/DPlayer.vue";
import Review from "../../../components/common-v2/review.vue";

import sharePC from "@/components/share.vue";
export default {
  components: {
    DPlayer,
    Review,
    sharePC

    // classTest,
  },
  data() {
    return {
      isRead: false,
      viewImageFlag: false,
      imgUrl: "",
      isShoreUrl: "", // 腾讯云分享地址
      user_login_id: this.$g.user_id,
      videoid: this.$route.query.id,
      is_download: this.$route.query.is_download,
      is_complete: 0, // 0是未经过专辑进入观看视频的，1：经过专辑进入观看视频，未看完；2：经过专辑进入观看视频，已看完',
      // 从优课专辑跳到此页面：
      album_id: this.$route.query.album_id,
      modelType: this.$route.query.modelType,
      ablumInterval: null,
      cutid: this.$route.query.cutId,
      videoName: "",
      fav_flag: false,

      videoFlag: false,


      videoCurrentTime: 0, //实时获取到的视频播放进度，带小数点的毫秒数
      activeName1: "first",
      classSore: 5,
      profile: "",
      //课程介绍 / 讲师介绍：
      lengthString: "", //视频长度 字符串 格式"00:00:00"
      videolength: 0,
      courseData: {},
      pointData: [],
      otherVideoData: [],

      // 视频资源下载：
      videoFileData: [],
      page_index1: 1,
      page_size1: 3,
      total_number1: 0,
      // 观看过的人：
      sawPeopleData: [],
      page_index2: 1,
      page_size2: 15,
      total_number2: 0,

      //分辨率
      resolutionOption: {},
      resolution: "",
      videoCreaterId: "", //当前视频创建者的id
      // timer: null,
      checkResolutionStatus: false,
      showAlert: false, // 若$alert弹窗显示时值为true，反则为false
      showShare: false, //显示分享弹窗
      shareLink: "", // 分享地址
      changeCopy: 1, // 选择复制

      //评分评论
      sortFlag: true,
      comment_id: null,
      comment_flag: false,
      page_index: 1,
      page_size: 5,
      order_type: "time_down",
      commentListData: [],
      total_number: 0,
      o_imgChecked: false,
      o_imgDisabled: false,
      screenshotUrl: "", //截图图片路径
      uploadOptions: {
        target: this.BASE_URL + "/api/resource/res_upload",
        headers: { Authorization: `Bearer ` + this.$g.access_token },
        testChunks: false,
        allowDuplicateUploads: true,
      },
      statusText: {
        success: this.$t("upload.success"),
        error: this.$t("upload.error"),
        uploading: this.$t("upload.uploading"),
        paused: this.$t("upload.paused"),
        waiting: this.$t("upload.waiting"),
      },
      countTimeForm: {
        video_id: this.$route.query.id,
        user_id: this.$g.user_id,
        total_time: 10,
        source: 1,
        ticket: "",
      },
      timeExpen: 0,
      timeInterval: null,
      videoSign: "",

      timer: null,
      view: false,
      commentLength: 0,
      shareLink: {
        img: '',
        name: '',
        notice: '',
        link: `${location.origin}/home/openclassDetail?id=${this.$route.query.id}&sharePC=true`,
        h5: `${location.origin}/wap/pages/video/details?id=${this.$route.query.id}&sharePC=true&mode=1`
      },

      videoInfo: {
        test_complete_status: 0,
      },
      testLoading: false,
    };
  },
  created() {

    this.turnBack();

  },
  beforeMount() {

  },
  computed: {
    intrArr() {
      //  课程介绍数据处理
      let keyWordStr = "";
      let saveTime = "";
      // 关键词处理
      if (!this.courseData || !this.courseData.keywords) {
        keyWordStr = this.$t("global.nokeyword");
      } else {
        this.courseData.keywords.forEach((element, index) => {
          if (index < this.courseData.keywords.length) {
            if (index === this.courseData.keywords.length - 1) {
              keyWordStr += element;
            } else {
              keyWordStr += element + ", ";
            }
          }
        });
      }
      if (this.courseData) {
        switch (this.courseData.save_month) {
          case 0:
            saveTime = this.$t("global.forever");
            break;

          case 6:
            saveTime = this.$t("global.halfYear");
            break;

          case 12:
            saveTime = this.$t("global.oneYear");
            break;

          default:
            saveTime = this.courseData.save_month + this.$t("global.month");
            break;
        }
      }
      if (this.courseData && this.courseData.sources_id !== 0) {
        //  sources_id !== 0关联的视频，不显示关键字和保存时间
        keyWordStr = "";
        saveTime = "";
      }
      return [
        {
          label: this.$t("global.keyword"),
          content: keyWordStr,
        },
        {
          label: this.$t("homepage.videoCate"),
          content: this.courseData?.cate_name ?? this.$t("global.noData"),
        },
        {
          label: this.$t("global.keepTime"),
          content: saveTime,
        },
        {
          label: this.$t("customer.coursevalue"),
          content: this.courseData
            ? this.courseData.notice
            : this.$t("global.noData"),
        },
        {
          label: this.$t("homepage.videoIntr"),
          content: this.courseData
            ? this.courseData.profile
            : this.$t("global.noData"),
        },
      ];
    },
    saveTime() {
      return (month) => {
        if (month == 0) {
          return this.$t("global.forever");
        } else if (month == 6) {
          return this.$t("global.halfYear");
        } else if (month == 12) {
          return this.$t("global.oneYear");
        } else {
          return month + this.$t("global.month");
        }
      };
    },
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
    },
  },
  mounted() {
    !sessionStorage.getItem("SharePage") && this.getCommentList();
    window.onbeforeunload = () => {
      return this.videoRecord();
    };

    this.getTicket();
    // this.checkVideoAuth()
    window.scrollTo({
      top: 0,
    });



  },
  beforeDestroy() {
    document.body.removeAttribute("oncontextmenu"); // 移除禁止右键
    this.videoRecord();
    this.player && this.player.dispose();
    sessionStorage.removeItem("SharePage");

    clearInterval(this.timer);
  },
  destroyed() {
    clearInterval(this.timeInterval);
    // this.getVideoCountTime();
    clearInterval(this.ablumInterval);
  },
  methods: {


    handlePlay() {
      console.info('handlePlay')
      this.timer & clearInterval(this.timer);
      this.countTimeForm.total_time = 10
      this.countTime()
    },
    handleEnd() {
      console.info('handleEnd')
      this.countTimeForm.total_time = 0
      clearInterval(this.timer);
    },

    handlePause() {
      this.countTimeForm.total_time = 0
      clearInterval(this.timer);
    },

    changeCount(count) {
      this.commentLength = count;
    },
    openRead() {
      this.isRead = true;
    },
    turnBack() {
      let user_id = JSON.parse(sessionStorage.getItem("user_info_str"))
        ? JSON.parse(sessionStorage.getItem("user_info_str")).id
        : "";

      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll()
          this.$message.warning(this.$t("global.authorityMessage"));
          setTimeout(() => {
            this.$router.push("/homeindex");
          }, 500);
        } else {
          this.getVideo();
          this.getVideoDetail();
          this.getSawPeople();
          this.recordClickCount();
        }
      };


      if (user_id) {

        const type = this.$route.query.modelType || 1
        const type_id = this.$route.query.album_id || +this.videoid
        // const type_id = this.$route.query.id
        this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
          params: { type, type_id, user_id },
          func: { success },
        });
      } else {
        this.$message.closeAll()
        this.$message.warning(this.$t("global.authorityMessage1"));
        setTimeout(() => {
          // this.$router.replace("/");
          this.$router.push("/homeindex");
        }, 500);
      }
    },
    checkVideoAuth() {
      this.turnBack();
      // let success = (res) => {
      //   let limit_type = res.data.limit_type;
      //   const userInfo = JSON.parse(sessionStorage.getItem("user_info_str"))
      //   console.log(limit_type);
      //   console.info(userInfo,'sdada')
      //   if ([1,2].includes(limit_type) || [2,3].includes(userInfo.check_role) ) {
      //     return;
      //   } else {
      //     this.turnBack();
      //   }
      // };
      // this.$ajax.get("/api/video/get_check_by_video_id", {
      //   params: { type: 1, type_id: this.videoid },
      //   func: { success },
      // });
    },
    countTime() {
      this.timer = setInterval(() => {
        // 2023-4-14 后端说这两个要改成同时进行
        // if (sessionStorage.getItem("tencentCloud") == 0) {
        this.getVideoCountTime(); // 会议版——十秒统计一次观看时长
        // } else {
        this.getVideoView(); //商学院统计观看记录方法
        // }
      }, 10000);
    },
    notCountTime() {
      // clearInterval(this.timer);
    },
    //获取凭证
    getTicket() {
      let params = {
        video_id: this.$route.query.id,
        user_id: this.$g.user_id,
      };
      let success = (data) => {
        this.countTimeForm.ticket = data.data.ticket;
        // this.getVideoCountTime()
      };
      this.$ajax.get("api/video/video_views_count_ticket", {
        params: params,
        func: { success },
      });
    },

    //原会议版观看记录，这里改动
    getVideoCountTime() {
      let params = this.countTimeForm;
      let success = (res) => {
        // console.log(res, this.countTimeForm,'提交观看时间')
        this.view = !(res.data.status === false);
      };
      this.$ajax.post("api/video/video_views_count", params, {
        func: { success },
      });
    },

    //商学院观看记录，
    getVideoView() {
      let params = this.countTimeForm;
      let success = (res) => {
        // console.log('提交观看记录', res)
        this.view = !(res.data.status === false);
      };
      this.$ajax.post("api/video/video_views_company", params, {
        func: { success },
      });
    },

    //  用画布方法截图
    screenShot(e) {
      if (e) {
        let c = document.getElementById("myCanvas");
        let ctx = c.getContext("2d");
        // 截图的图片来源是播放器，此处videoPlayer_html5_api是video标签的id名字，是videojs播放器自动生成的
        let sourceImg = document.querySelector(".dplayer-video-current");
        ctx.drawImage(sourceImg, 0, 0, 1200, 672);
        let pngBase64 = c.toDataURL("image/png");
        // 把base64图片转成file格式
        // 由于文件上传后台是根据文件name里面的后缀名来定义返回值里面文件路径的后缀名，此处要加上图片后缀名
        let pngFile = this.dataURLtoFile(
          pngBase64,
          this.$t("homepage.commontCutImage") + ".png"
        );
        // 把截图追加到上传插件
        this.$refs.uploader.uploader.addFile(pngFile);
        // 让插件上传截图
        this.$refs.uploader.uploader.resume();
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    //截图上传成功
    fileSuccess(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
      mess = handleResponseData(mess);
      if (parseInt(mess.data.status) === 1) {
        this.screenshotUrl = mess.data.file_path;
      }
    },
    //截图上传失败
    fileFail(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
      if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
        let callbcak = (data) => {
          this.uploadRetryTimes--;
          this.$refs.uploader.uploader.retry(file);
        };
        this.get_access_token(callbcak);
      } else {
        this.$message.error(mess.msg);
      }
    },
    viewImage(path) {
      this.viewImageFlag = true;
      this.imgUrl = this.BASE_URL + "/" + path;
    },
    // 发表评论
    addComent() {
      if (this.user_login_id == 0) {
        this.$message.warning(this.$t("homepage.needLogin"));
        return;
      }
      if (this.profile == "" || this.profile.trim().length == 0) {
        this.$message.warning(this.$t("homepage.addComments"));
        return;
      }
      let _method, _params;
      if (this.comment_id != null) {
        _method = "put";
        _params = {
          id: this.comment_id,
          user_id: this.user_login_id,
          res_id: this.videoid,
          origin: 0,
          score: this.classSore * 2,
          content: this.profile,
          image_path: this.screenshotUrl,
        };
      } else {
        _method = "post";
        _params = {
          user_id: this.user_login_id,
          res_id: this.videoid,
          origin: 0,
          score: this.classSore * 2,
          content: this.profile,
          image_path: this.screenshotUrl,
        };
      }

      let success = (res) => {
        this.comment_flag = true;
        this.o_imgChecked = false;
        this.screenshotUrl = "";
        this.$message.success(res.msg);
        this.getCommentList();
        this.getIntroduction();
      };
      this.$ajax({
        url: "api/comment/comment",
        method: _method,
        data: _params,
        func: {
          success: success,
        },
      });
    },
    //评分评论：时间按钮
    sortingData() {
      this.sortFlag = !this.sortFlag;
      this.sortFlag == true
        ? (this.order_type = "time_down")
        : (this.order_type = "time_up");
      this.getCommentList();
    },
    //评论列表
    getCommentList() {
      let success = (res) => {
        this.total_number = parseInt(res.data.data_sum);
        this.page_index = parseInt(res.data.page_index);
        this.commentListData = res.data.data;
        this.commentListData.forEach((item) => {
          if (!item.avatar_path.includes("http")) {
            item.avatar_path = this.BASE_URL + item.avatar_path;
          }
        });
      };
      this.$ajax({
        url: "api/video/video_comment_list",
        method: "get",
        params: {
          page_index: this.page_index,
          page_size: this.page_size,
          res_id: this.videoid,
          order_type: this.order_type,
        },
        func: {
          success: success,
        },
      });
    },
    // 删除评论
    delComent(_id) {
      this.$confirm(
        this.$t("homepage.delCommentsWhat") + "?",
        this.$t("global.tips"),
        {
          confirmButtonText: this.$t("global.sure"),
          cancelButtonText: this.$t("global.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let success = (res) => {
            this.$message.success(this.$t("homepage.delSuccess"));
            this.comment_flag = false;
            this.comment_id = null;
            this.classSore = 0;
            this.profile = "";
            this.getCommentList();
            this.getIntroduction();
          };
          this.$ajax({
            url: "api/comment/comment",
            method: "delete",
            params: {
              id: _id,
            },
            func: {
              success: success,
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("homepage.notDel"),
          });
        });
    },
    // 编辑评论
    editComent(_item) {
      this.o_imgDisabled = true;
      this.comment_flag = false;
      this.comment_id = _item.id;
      this.classSore = _item.score / 2;
      this.profile = _item.content;
      this.screenshotUrl = _item.image_path;
    },
    getGlobalConfig() {
      let success = (res) => {
        if (res.data.copyright_show === 1) {
          this.openRead();
        }
      };
      this.$ajax.get("api/video/live_app_show", {
        params: {
          type: 4,
        },
        func: { success },
      });
    },
    getVideoDetail() {
      let success = (res) => {
        this.videoSign = res.data.video_sign;
        this.videoFileData = res.data.attachment_info
          ? res.data.attachment_info
          : [];
        this.isShoreUrl = res.data.path;
        let copyright_status = res.data.copyright_status;
        this.videoInfo = res.data;
        this.activeName1 =
          this.videoInfo.task_test_url !== "" ? "first" : "second";
       
        if (copyright_status === 1) {
          this.getGlobalConfig();
        }

        // if (Number(this.isTencentCloud)) {
        //   this.playerOptions.sources = [
        //     {
        //       type: "video/mp4", // 类型
        //       src: this.isShoreUrl, // 视频播放路径
        //     },
        //   ];
        // } else {
        //   this.playerOptions.sources = [
        //     {
        //       type: "video/mp4", // 类型
        //       src: this.BASE_URL + "/" + res.data.path, // 视频播放路径
        //     },
        //   ];
        // }
        // this.initPlay();
      };
      this.$ajax.get("api/video/video", {
        params: { videoid: this.$route.query.id },
        func: { success },
      });
    },
    /**
     * 播放器初始
     */
    // initPlay() {
    //   let self = this;
    //   this.player && this.player.dispose();
    //   let videoMarkPlayer = document.getElementById("newMarkDom");

    //   videoMarkPlayer.innerHTML =
    //     '<video id="videoMarkPlayer" class="video-js vjs-big-play-centered vjs-fluid" width="100%" height="100%"  crossorigin="anonymous"> </video>';
    //   this.player = this.$videojs(
    //     "videoMarkPlayer",
    //     this.playerOptions,
    //     function onPlayerReady() { }
    //   );

    //   // 初始化音量50%
    //   this.player.volume(0.5);

    //   if (!sessionStorage.getItem("SharePage")) {
    //     let userInfo = JSON.parse(sessionStorage.getItem("user_info_str"));
    //     var html = `<div class="dotting_time" current_time="">
    //                                 <p>${userInfo.name}</p>
    //                                 <p>${userInfo.number}</p>
    //                             </div>`;
    //     this.player.el_.insertAdjacentHTML("beforeend", html);
    //   }

    //   this.player.on("play", function () {
    //     self.onSlicePlay();

    //     clearInterval(self.timer);
    //     self.timer = setInterval(() => {
    //       self.getVideoCountTime(); //十秒统计一次观看时长
    //     }, 10000);
    //     console.log(self.timer);
    //   });

    //   this.player.on("pause", function () {
    //     clearInterval(self.timer);
    //     console.log(self.timer);
    //   });

    //   this.player.on("timeupdate", function () {
    //     self.onPlayerTimeupdate();
    //   });

    //   this.player.on("loadedmetadata", function () {
    //     self.onPlayerLoadeddata();
    //   });
    // },
    getCopyVal(val) {
      this.getShareLink();

      if (this.changeCopy === 2) {
        const timer = setTimeout(() => {
          clearTimeout(timer)
          this.initQrCode()
        }, 500)
      }
    },
    // 分享
    share() {
      this.showShare = true;
      this.getShareLink();
    },
    initQrCode() {

      new QRCode('qrcode', {
        width: 200,
        height: 200,
        text: this.shareLink,
      })
    },

    getShareLink() {
      let success = (data) => {
        const webShare = `${location.origin}/home/openclassSharePage?id=${this.$route.query.id}&sharePC=true`;
        // const webShare = `${location.origin}/home/openclassSharePage?video_sign=${this.videoSign}&id=${this.$route.query.id}&share=${data.data}&SharePage=true`;
        // const h5Share = `${location.origin}/wap/pages/video/details?video_sign=${this.videoSign}&SharePage=true&share=${data.data}`;
        // const h5Share = `${location.origin}/wap/pages/video/share?video_sign=${this.videoSign}&id=${this.$route.query.id}&share=${data.data}&SharePage=true`;
        const h5Share = `${location.origin}/wap/pages/video/details?id=${this.$route.query.id}&sharePC=true&model=1`;
        this.shareLink = this.changeCopy === 1 ? webShare : h5Share;


      };
      this.$ajax({
        url: "/appapi/login/shareH5Url",
        method: "get",
        data: {
          type: 0, // 模块类型：0：视频；1：资源；2：直播；3：专辑
          id: this.$route.query.id, // 资源id
        },
        func: {
          success,
        },
      });
    },
    // 复制分享地址
    copyShareLink() {
      let input = document.createElement("input");
      input.value = this.shareLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.showShare = false;
      this.$message.success(this.$t("global.copySuccess"));
    },
    /**
     * 改变进度条
     */
    // onSlicePlay() {
    //   this.debounce(() => {
    //     var normal_currentTime = this.player.currentTime();
    //     var unnormal_currentTime = this.player.currentTime();
    //     if (normal_currentTime.toString() == unnormal_currentTime.toString()) {
    //       this.player.pause();
    //       this.player.play();
    //     }
    //   }, 100);
    // },
    //延迟处理
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // 如果设定为immediate===true，因为开始已经调用过了此处无需调用
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          }
        }
      };
      return function(...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }

        return result;
      };
    },
    //实时获取视频播放的信息
    // onPlayerTimeupdate() {
    //   //实时获取当前的播放进度时间（毫秒数，带小数点）
    //   this.videoCurrentTime = this.player.currentTime();
    // },

    // 视频加载完毕装备就绪
    // onPlayerLoadeddata() {
    //   this.videolength = this.player.duration(); //获取视频的长度
    // },
    //获取视频URL、名称
    getVideo() {
      let success = (data) => {
        this.getIntroduction();

        let result = data.data;
        // console.log('res',result)
        if (result && result.point.length > 0) {
          if (!this.modelType) {
            this.pointData = result.point; //打点的数据
            this.pointData = JSON.parse(
              JSON.stringify(this.pointData)
                .replace(/video_time/g, "time")
                .replace(/comment/g, "text")
            );
          }

          // console.log('pointdata',this.pointData)
        }
      };
      this.$ajax({
        url: "api/video/video_point_list",
        method: "get",
        params: {
          videoid: this.videoid,
        },
        func: {
          success: success,
        },
      });
    },
    //视频观看记录
    videoRecord() {
      let success = (data) => {
        // console.log(data, '观看记录')
      };
      let fail = (data) => { };
      this.$ajax({
        url: "api/video/video_record",
        method: "post",
        data: {
          video_id: this.videoid,
          start_time: this.$refs?.dplayer?.videoCurrentTime,
          user_id: this.user_login_id,
          length: this.videolength,
          is_complete: this.is_complete,
        },
        func: {
          success: success,
          fail: fail,
        },
      });
    },

    //右边栏下载按钮：
    downLoadFile() {
      window.location.href =
        this.BASE_URL +
        "/index/openclass/videodownload?id=" +
        this.videoid +
        "&type=0&userid=" +
        this.user_login_id;
      //添加下载数
      this.addDownLoadCount();
    },
    //添加下载数
    addDownLoadCount() {
      let success = (data) => {
        // 更新下载数量
        let success = (data) => {
          // this.courseData.downloads = data.data.downloads;
          this.getIntroduction("noVideo");
        };
        this.$ajax({
          url: "api/video/video",
          method: "get",
          params: {
            videoid: this.videoid,
            userid: this.user_login_id,
            cutid: this.cutid,
          },
          func: {
            success: success,
          },
        });
      };
      this.$ajax({
        url: "index/resource/add_download_nums",
        method: "post",
        data: {
          id: this.videoid,
          type: 0,
          userid: this.user_login_id,
        },
        func: {
          success: success,
        },
      });
    },
    //增加播放次数
    recordClickCount() {
      let success = (data) => {
        // console.log(data.data);
        this.getIntroduction();
      };
      this.$ajax({
        url: "api/video/video_click",
        method: "post",
        data: {
          video_id: this.videoid,
        },
        func: {
          success: success,
        },
      });
    },

    // 点击红心收藏
    addCollection() {
      if (this.user_login_id == 0) {
        this.$message.warning(this.$t("homepage.needLogin"));
        return false;
      }
      let success = (data) => {
        this.getIntroduction("noVideo");
        if (this.fav_flag) {
          this.$message.success(this.$t("global.collect0"));
        } else {
          this.$message.success(this.$t("global.collect1"));
        }
      };
      let _methods;
      if (this.fav_flag) {
        _methods = "delete";
      } else {
        _methods = "post";
      }
      this.$ajax({
        url: "api/video/video_favourite",
        method: _methods,
        data: {
          res_id: this.videoid,
          userid: this.user_login_id,
        },
        func: {
          success: success,
        },
      });
    },

    // 版权声明 
    handleClickCopyright() {
      this.isRead = true;
    },

    checkResolution() {
      let self = this;
      if (!document.querySelector(".transcoding")) {
        let playerBar = document.querySelector(".vjs-control-bar"),
          fullScreen = document.querySelector(
            ".vjs-fullscreen-control.vjs-control.vjs-button"
          ),
          div = document.createElement("div"),
          dl = document.createElement("dl"),
          arr = this.resolutionOption,
          dt = document.createElement("dt");
        div.className = "transcoding";

        if (arr["1080P"]) {
          let dd = document.createElement("dd");
          dd.innerText = "1080P";
          dl.appendChild(dd);
        }

        if (arr["720P"]) {
          let dd = document.createElement("dd");
          dd.innerText = "720P";
          dl.appendChild(dd);
        }

        if (arr["480P"]) {
          let dd = document.createElement("dd");
          dd.innerText = "480P";
          dl.appendChild(dd);
        }

        if (dl.children.length) {
          dt.className = "acitve";
          dt.innerText = dl.children[0].innerText;
          dl.appendChild(dt);
          div.appendChild(dl);
          playerBar.insertBefore(div, fullScreen);
        }

        let dlChildren = [...dl.children].slice(0, -1);

        function changeUrl1(e) {
          if (dt.innerText == e.target.innerText) {
            return;
          }
          let _now = parseInt(self.player.currentTime());
          dt.innerText = e.target.innerText;
          self.player.pause();
          self.player.src({
            type: "application/x-mpegURL",
            src: arr[e.target.innerText],
          });
          self.player.load();
          self.player.play();
          setTimeout(() => {
            self.player.currentTime(_now);
          }, 500);
        }
        for (let i = 0; i < dlChildren.length; i++) {
          dlChildren[i].addEventListener("click", changeUrl1, true);
        }
      }
    },
    //课程介绍
    getIntroduction(hasVideo) {
      let success = (data) => {
        // console.log(data.data,'cloud_file_id', '课程介绍')
        if (!data.data.transform_status && !this.showAlert) {
          this.showAlert = true;
          let content = this.$t("homepage.transcoding");
          this.$alert(content, this.$t("global.tips"), {
            confirmButtonText: this.$t("global.sure"),
            callback: (action) => {
              this.$router.back();
              return false;
            },
          });
        } else if (!data.data.transform_status && this.showAlert) {
          return;
        }

        // 分辨率对应的视频路径：
        // this.resolutionOption = {
        //     '1080P': data.data['1080P'] == '' ? '' : data.data['1080P'],
        //     '720P': data.data['720P'] == '' ? '' : data.data['720P'],
        //     '480P': data.data['480P'] == '' ? '' : data.data['480P']
        // };

        // if (!this.checkResolutionStatus) {
        //     this.checkResolution();
        //     this.checkResolutionStatus = true;
        // }

        this.videoCreaterId = data.data.create_id;
        this.fav_flag = data.data.user_isfav;
        this.courseData = data.data;

        this.shareLink.name = this.courseData?.name || ''
        this.shareLink.img = this.courseData?.picture_url || ''
        this.shareLink.notice = this.courseData?.notice || ''
        if (!this.courseData.avatar_path.includes("http")) {
          this.courseData.avatar_path =
            this.BASE_URL + this.courseData.avatar_path;
        }
        this.videoFlag = true;
        // console.log('courseData', this.courseData)
        this.videoName = data.data.name;

        if (hasVideo != "noVideo") {
          //此处为了下载和收藏视频时，既显示增加的点击数量、下载数，又不重新赋值视频的问题（重新赋值，导致视频重新播放）
          //  if(Number(this.isTencentCloud)) {
          //  }else{
          //     this.player.src({
          //         type: 'application/x-mpegURL',
          //         src: data.data.pc_play_url
          //     });
          //     this.player.play();
          // }
        }

        this.comment_flag = Object.keys(data.data.mark_comment).length != 0;

        // let _length = data.data.length.split(":");
        // this.videolength =
        // parseInt(_length[0] * 3600) +
        // parseInt(_length[1] * 60) +
        // parseInt(_length[2]); // 时间转成秒数
        // console.log(this.videolength)
        /**
         * 通过 /api/video/video 获取去的 create_id 和userid 为0 时 不再请求//api/video/video_list  接口
         * @DateTime 2020-03-14T10:43:12+0800
         * @qiu_m
         * @param    {[type]}                 data.data.userid !             [description]
         * @return   {[type]}                                  [description]
         */
        if (data.data.userid != 0 && data.data.create_id != 0) {
          this.getTeacherVideo(data.data.userid);
        }

        if (data.data.status == 0) {
          this.$message.error(this.$t("my.homepage.videoDeleted"));
          this.$router.push("/openclass/");
        }
      };
      this.$ajax.get("api/video/video", {
        params: {
          videoid: this.videoid,
          userid: this.user_login_id,
          cutid: this.cutid,
        },
        func: {
          success: success,
        },
      });
    },
    //切换分辨率
    changeResolution(val, key) {
      // console.log(val,key)
      let _now = this.videoCurrentTime;
      this.resolution = key;
      this.player.src({
        type: "rtmp/mp4",
        src: val,
      });
      this.player.play();
      setTimeout(() => {
        this.player.currentTime(_now);
      }, 100);
    },
    //获取讲师介绍：其他课程
    getTeacherVideo(_id) {
      
      let success = (data) => {
        this.otherVideoData = data.data.data;
      };
      this.$ajax({
        url: "api/video/video_list",
        method: "get",
        params: {
          create_id: _id,
          page_size: 3,
        },
        func: {
          success: success,
        },
      });
    },

    // 下载资料
    down(obj) {
      window.location.href =
        this.BASE_URL +
        "/index/openclass/download_video_file_huiyi?id=" +
        obj.id;
    },
    //看过的人
    getSawPeople() {
      let success = (res) => {
        this.total_number2 = res.data.data_sum;
        this.sawPeopleData = res.data.data;
        this.sawPeopleData.forEach((item) => {
          item.avatar_path = item.avatar_path.includes("http")
            ? item.avatar_path
            : this.BASE_URL + item.avatar_path;
        });
        // console.log(this.sawPeopleData)
      };
      this.$ajax({
        url: "api/video/video_record_user",
        method: "get",
        params: {
          videoid: this.videoid,
          page_index: this.page_index2,
          page_size: this.page_size2,
        },
        func: {
          success,
        },
      });
    },

    change_page(val, type) {
      if (type == "1") {
        this.page_index1 = val;
      } else if (type == "2") {
        this.page_index2 = val;
        this.getSawPeople();
      }
    },
    goback() {
      this.$router.go(-1);
    },
    
    // 刷新试题
    handRefreshTest() {
      let isClick = true;
      this.testLoading = true;
      if (isClick) {
        isClick = false;
        let success = (res) => {
          if (res) {
            this.$message.success("刷新成功");
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
          this.testLoading = false;
          isClick = true;
        };
        let fail = (res) => {
          this.testLoading = false;
          this.$message.error(res.msg)
        }
        this.$ajax.get("api/assignment/getQingAnswerRefreshRecord", {
          params: {
            task_test_id: this.courseData.task_test_id,
            user_id: this.$g.user_id
          },
          func: { success, fail },
        });
      }
    },
    // 跳转轻速运
    goTest(status) {
      if (this.videoInfo.task_test_url) {
        // 最后一次强制打开
        // video_complete_status:1 已完成  不跳转
        if (status === 1) {
          return;
        }
        let success = (res) => {
          console.log(res);
          window.open(res.data);
        };
        this.$ajax.get("api/assignment/getQingCasFrontTestUrl", {
          params: {
            number: JSON.parse(sessionStorage.getItem("user_info_str")).number,
            test_url: this.videoInfo.task_test_url,
          },
          func: { success },
        });
      }
    },
  },
};
</script>


<style lang="scss">
@import url("../../../assets/css/video.css");

.qrcode_container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.video-count {
  height: 4rem;
  line-height: 4rem;
  display: flex;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    color: #666666;

    img {
      width: 1.6rem;
      margin-right: 0.8rem;
    }

    .adjust {
      width: 1.4rem;
      margin-left: 3rem;
    }
  }
}

#viewImageFlag {
  .el-dialog {
    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}

.el-dialog__body {
  padding: 30px 20px 20px;
}

.transcoding {
  position: relative;
  width: 56px;
  cursor: pointer;

  >dl {
    position: absolute;
    bottom: 0;
    width: 100%;

    &:hover dd {
      display: block;
    }

    >dd {
      display: none;
      height: 42px;
      line-height: 42px;
      text-align: center;
      color: #fff;
      background: rgba(0, 0, 0, 0.4);

      &:hover {
        font-weight: 600;
        background: rgba(0, 0, 0, 0.8);
      }
    }

    >.acitve {
      height: 42px;
      line-height: 42px;
      text-align: center;
      color: #fff;
      // font-weight: 600;
      background: transparent;
    }
  }
}

.openclass-live {
  .video_profile {
    max-height: 350px;
    overflow: auto;

    >span>p {
      line-height: 1.5;
    }

    img {
      max-width: 100% !important;
      height: auto;
      object-fit: contain;
    }
  }

  .share_text {
    font-size: 16px;
    line-height: 25px;
    word-break: keep-all;

    .el-radio-group {
      margin: 20px 0 15px 0;
    }

    .el-radio__label {
      font-size: 15px;
    }
  }

  .dotting_time {
    width: 138px;
    height: 54px;
    padding-top: 4px;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 555;
    font-size: 14px;
    border-radius: 2px;

    p:nth-child(1) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.live-banner-bgc {
  margin-top: 9%;
  position: relative;
  // background-image: url("../../../assets/images/bgc.png") !important;
  background-size: cover;
  width: 100%;
  overflow: hidden;
}

.class-live-banner {
  height: 50px;
  line-height: 50px;
  background: #fff;

  .live-banner-tit {
    font-size: 16px;
    cursor: pointer;
  }

  .Shape_07 {
    margin-left: 32px;
    margin-right: 10px;
    color: #000;
  }

  i,
  strong,
  a {
    vertical-align: middle;
  }

  strong {
    // margin-left: 15px;
    font-size: 20px;
    color: #000;
  }

  .live-banner-r {
    font-size: 14px;
    color: #b1bdc2;
    // margin-right: 30px;
  }

  // .train-file-l-share>span {
  //   line-height: 20px;
  //   margin-right: 10px;
  //   font-size: 12px;
  //   color: #000;
  // }

  .train-file-l-share>div {
    display: inline-block;
    vertical-align: middle;
  }

  .train-file-l-share>div>a {
    margin: 0 10px;
  }
}

.video-play-cont {
  // margin-left: 0px;
  margin-bottom: 20px;
  width: 1200px;

  // overflow: hidden;
}

.video-box {
  width: 100%;
  height: 674px;
  overflow: hidden;
  // position: relative;
  // .waterMark {
  //   width: 168px;
  //   height: 54px;
  //   border-radius: 2px;
  //   background-color: #000;
  //   position: absolute;
  //   top: 10px;
  //   right: 10px;
  //   opacity: 0.5;
  // }

  // .videoMarkPlayer-dimensions.vjs-fluid {
  //   padding-top: 56%;
  // }

  // &:hover .resolution {
  //   visibility: visible;
  //   opacity: 1;
  // }

  // .resolution {
  //   visibility: hidden;
  //   opacity: 0;
  //   transition: visibility 1s, opacity 1s;
  //   width: 42px;
  //   height: 42px;
  //   line-height: 42px;
  //   position: absolute;
  //   right: 42px;
  //   bottom: 0;
  //   font-size: 12px;
  //   color: #fff;
  //   cursor: pointer;

  //   &:hover ul {
  //     display: block;
  //   }

  //   span {
  //     display: inline-block;
  //     width: 100%;
  //     height: 100%;
  //     text-align: center;
  //   }

  //   ul {
  //     display: none;
  //     width: 100%;
  //     position: absolute;
  //     right: 0;
  //     bottom: 42px;
  //     background-color: rgba(115, 133, 159, 0.5);

  //     li {
  //       height: 20px;
  //       line-height: 20px;
  //       text-align: center;

  //       &:hover {
  //         background-color: rgba(115, 133, 159, 0.5);
  //       }
  //     }
  //   }
  // }
}

// rightSideBar  start
.video-sidebar-box {
  position: absolute;
  top: 0;
  right: 0px;
  z-index: 10;
  height: 100%;
  transition: right 500ms;
  padding-top: 300px;

  .download-btn {
    padding: 12px 14px;
    background: #E62125;
    color: #fff;
    text-align: center;
    cursor: pointer;

    p {
      margin-top: 10px;
      font-size: 14px;
      margin-top: 10px;
      height: 18px;
      line-height: 18px;
    }

    .but_dolondup {
      margin: 0 auto;
      display: block;
      width: 28px;
      height: 28px;
      background: url("../../../assets/images/xiazai@2x.png") no-repeat;
      background-size: contain;
    }
  }
}

.live-commont-l .el-tabs__content .el-tab-pane .i_reviewArea_i {
  margin-bottom: 27px;
}

.i_reviewArea_i>span>em {
  color: #666666;
  line-height: 16px;
  margin-top: 10px;
  display: block;
}

.i_reviewArea_ls {
  border-bottom: 1px solid #efefef;
  padding: 20px;
  min-height: 16px;
  line-height: 16px;

  &:first-child {
    border-top: 1px solid #efefef;
  }
}

.i_reviewArea_ls>div {
  float: left;
  width: 664px;
}

.i_reviewArea_ls>div>span {
  line-height: 19px;
  margin-right: 20px;
  color: #000;
}

.i_reviewArea_ls>div>a {
  color: #E62125;
  margin-right: 20px;
}

.common-bar {
  .question-bar-input {
    border-bottom: 1px solid #dcdfe6;
  }

  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__item {
    width: 210px;
    padding: 0;
    text-align: center;
  }

  .el-tabs__item.is-active {
    background-color: #a8ecfd;
  }

  .el-tabs__active-bar {
    display: none;
  }

  .textarea {
    margin: 20px 10px;
    position: relative;

    .numberWord {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }

  .cut-img {
    padding: 0 10px 20px;
    border-bottom: 1px solid #dcdfe6;
  }

  .but_addamage {
    margin-right: 10px;
  }

  .el-button {
    width: 80px;
  }

  .question-div {
    overflow-y: scroll;
  }

  .preson-question {
    height: 550px;
  }

  .all-question {
    height: 738px;
  }

  .comment-li-item {
    padding: 20px 0;
    margin: 0 20px;
    border-bottom: 1px solid #e0e0e0;

    a {
      display: block;
      float: left;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }
  }

  .comment-li-box {
    float: none;
    margin-left: 60px;

    .comment-user {
      color: #666;
    }

    .textarea {
      margin: 20px 0;
    }
  }

  .comment-content {
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 15px;
  }

  .comment-li-area {
    padding-bottom: 20px;
  }

  .img-card {
    position: relative;
    margin-bottom: 20px;

    .el-card__body {
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .tips-word {
    visibility: hidden;
    opacity: 0;
    width: 100%;
    height: 140px;
    line-height: 140px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(144, 147, 153, 0.5);
    text-align: center;

    span {
      padding: 20px;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 5px;
      border: 2px dashed #fff;
      color: #fff;
      cursor: pointer;
    }
  }

  .img-card .el-card__body:hover>.tips-word {
    visibility: visible;
    opacity: 1;
  }

  .comment-btns-tool {
    span {
      color: #2f6d8c;
    }

    i {
      cursor: pointer;
      margin-left: 15px;
      visibility: hidden;
    }
  }

  .comment-li-box:hover>.comment-btns-tool>i {
    visibility: visible;
  }

  .reply-tips {
    padding-top: 20px;
    box-sizing: border-box;

    span {
      display: block;
      padding: 10px 0;
      // color: #666;
      color: #E62125;
    }

    .role1 {
      color: #E62125;
    }
  }
}

.seePicDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    text-align: center;
  }

  .el-dialog__headerbtn {
    border-radius: 50%;
    top: -12px;
    right: -12px;
    padding: 3px;
    background-color: #fff;

    .el-dialog__close {
      padding: 3px;
      border-radius: 50%;
      background-color: #666;
      color: #fff;
    }

    .el-dialog__close:hover {
      background-color: #409eff;
    }
  }
}

// rightSideBar  end

// live-commont start

.live-commont {
  padding-bottom: 50px;
}

.live-commont-l {
  width: 900px;

  .el-tabs__header {
    background-color: #fff;
    //   // margin: 10px 0 10px;
    //   margin: 0;
    //   padding: 0 25px;
    //   background: #2C2E3F;
    //   border-radius: 3px 3px 0px 0px;
  }

  .el-tabs__nav-wrap::after,
  .el-tabs__active-bar {
    background-color: transparent;
  }

  .el-tabs__content {
    background-color: #fff;
    padding: 30px 35px 100px;

    .i_reviewArea_i {
      margin-bottom: 40px;

      span {
        display: block;
        float: left;
        text-align: center;
        margin-right: 100px;

        >i {
          display: block;
          width: 40px;
          height: 40px;
        }

        em {
          color: #666666;
          line-height: 16px;
          margin-top: 10px;
          display: block;
        }
      }

      .video01 {
        background: url("../../../assets/images/icon_bofang@2x.png") no-repeat;
        background-size: contain;
      }

      .comment01 {
        background: url("../../../assets/images/icon_pinglun@2x.png") no-repeat;
        background-size: contain;
      }

      .download01 {
        background: url("../../../assets/images/icon_xiazai@2x.png") no-repeat;
        background-size: contain;
      }
    }
  }

  .i_reviewArea_ls {
    border-bottom: 1px solid #efefef;
    padding: 15px 0;

    .review-ls-tit {
      float: left;
      display: block;
      font-size: 14px;
      color: #666;
      width: 140px;
      margin-right: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .user_info,
    .user_profile,
    .teacher_video {
      float: left;
      width: 600px;

      a {
        color: #E62125;
        margin-right: 20px;
      }
    }

    .video_notice,
    .video_profile {
      word-wrap: break-word;
      word-break: break-all;
    }

    .user_profile p {
      word-wrap: break-word;
      word-break: break-all;
    }

    .i_teacherHs {
      span {
        display: block;
      }

      span:nth-of-type(1) {
        font-size: 16px;
        line-height: 40px;
      }

      a {
        cursor: auto;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: #efefef;
      }
    }
  }

  .video_category span {
    margin-right: 0;
  }

  .discuss-area {

    .stration,
    .el-rate {
      vertical-align: middle;
      font-size: 14px;
    }

    .el-rate {
      display: inline-block;
      width: 80%;
    }

    .el-textarea__inner {
      font-size: 12px;
    }

    .textarea {
      margin: 20px 0;
      position: relative;

      .numberWord {
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }
  }

  .commont-list-top {
    border-bottom: 1px solid #e0e0e0;

    span {
      font-size: 14px;
      margin-right: 20px;
    }

    .el-button {
      color: #000;
    }

    .sortGery {
      color: #338efc;
    }
  }

  .comment-ls {
    border-bottom: 1px solid #e0e0e0;
    padding: 20px 0;

    .reviewer_img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      display: block;
    }

    .reviewer-info {
      margin-left: 80px;
    }

    .i_videoReview_ip {
      line-height: 42px;
      margin-bottom: 5px;
      color: #666666;
    }

    .reviewer {
      a {
        margin-right: 20px;
        color: #666666;
        vertical-align: middle;
      }

      .el-rate {
        display: inline-block;
        vertical-align: middle;
      }
    }

    .create-time i,
    .create-time span {
      vertical-align: middle;
      margin-left: 20px;
    }

    .create-time i {
      cursor: pointer;
      visibility: hidden;
    }

    .review-text p {
      font-size: 14px;
      line-height: 18px;
      word-wrap: break-word;
      word-break: break-all;
    }

    .image_path {
      margin-top: 10px;
      width: 187.5px;
      height: 105px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .pageBox {
    padding-top: 30px;
  }

  .comment-ls:hover .create-time>i {
    visibility: visible;
  }

  .el-tabs__header.is-top {
    //   height: 40px;

    .el-tabs__nav-wrap.is-top {
      .el-tabs__nav-scroll {
        //       height: 40px;

        //       .el-tabs__nav.is-top {
        //         .el-tabs__item.is-top {
        //           font-size: 14px;
        //           padding: 0 15px;
        //           color: #fff;
        //         }

        .el-tabs__item.is-top.is-active {
          color: #e62125;
          //           background: #e62125;
          font-weight: bold;



          // }
        }

        .el-tabs__item.is-top:hover {
          color: #e62125;
        }
      }
    }
  }

  .el-tabs {
    .el-tabs__content {
      .el-tab-pane {
        &:nth-child(2) {
          >ul {
            .i_reviewArea_ls {
              border-top: 0 none;

              &:first-child {
                padding: 0 0 26px;

                .review-ls-tit {
                  line-height: 48px;
                }

                .user_info {
                  height: 48px;

                  >div {
                    >a {
                      width: 48px;
                      height: 48px;
                    }

                    >div>span {
                      line-height: 48px;
                    }
                  }
                }
              }

              &:nth-child(n + 2) {
                min-height: 20px;
                line-height: 20px;

                .teacher_video {
                  width: auto;

                  >a {
                    display: block;
                    padding-bottom: 8px;
                    width: auto;
                    margin: 0;
                    font-size: 14px;
                    color: #E62125;

                    &:last-child {
                      padding: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.live-commont-r {
  width: 280px;

  .i_reviewArea_pd {
    .i_dataDownload_t {
      padding: 0 20px;
      color: #fff;
      line-height: 40px;
      height: 40px;
      font-size: 14px;
      background: #2C2E3F;
      border-radius: 3px 3px 0px 0px;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    }

    &:nth-child(n + 2) {
      margin-top: 20px;
    }
  }
}

.i_dataDownload_c {
  background: #ffffff;
  padding: 10px 0;
  position: relative;

  .el-pagination {
    padding: 2px 20px;
  }

  #video_file {
    padding: 5px;
  }
}

.saw-btn {
  margin: 0 4px 20px 0;
  padding: 0;

  .r-avatar-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ccc;
    overflow: hidden;
  }
}

.saw-btn:nth-of-type(5n) {
  margin: 0 0 20px 0;
}

.el-popover {
  // background: rgba(80, 80, 80, 0.9);
  border: 0;

  .i_userIn {
    .i_userIn_txt {

      // padding: 25px 15px 30px;
      .avatar-pic {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        baackground-color: #ccc;
        overflow: hidden;
      }
    }

    .but_Collection02 {
      background-position: -757px -300px;
      width: 40px;
      height: 40px;
    }

    .saw-people-info {
      float: left;
      margin-left: 15px;

      span:nth-of-type(1) {
        display: block;
        height: 30px;
        font-size: 14px;
        line-height: 24px;
        line-height: 30px;
        color: #000000;
        // color: #fff;
      }

      span:nth-of-type(2) {
        display: block;
        font-size: 12px;
        line-height: 24px;
        color: #666666;
        margin-right: 10px;
      }

      span:nth-of-type(2) {
        display: inline-block;
        font-size: 12px;
        line-height: 24px;
        color: #666666;
      }
    }
  }
}

.dataFile {
  padding: 5px 20px;
}

.dataFile {
  a {
    float: left;
    display: block;
    font-size: 14px;
    line-height: 40px;
    max-width: 70%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  i {
    float: right;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
  }

  i:hover {
    box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
  }
}

.dataFile:hover {
  background: #effaff;
}

.dataFile:hover>a {
  color: #67aed2;
}

.dataFileBG {
  text-align: center;
  padding: 35px 10px;

  span {
    font-size: 12px;
    line-height: 65px;
    color: #2f6d8c;
    color: #999;
  }
}

.dataUser {
  padding: 10px 25px;

  a {
    cursor: auto !important;
  }
}

.dataUser>a,
.dataUser>div {
  float: left;
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 7px 20px 0;
  background: #5cbeb3;
  position: relative;
}

.dataUser>a>img,
.dataUser>div>img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  vertical-align: top;
  overflow: hidden;
}

.dataUser>a:hover,
.dataUser>div:hover {
  box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
}

.dataUser>a:hover .i_userIn,
.dataUser>div:hover .i_userIn {
  opacity: 1;
  visibility: visible;
}

.dataUser>a:nth-of-type(5n),
.dataUser>div:nth-of-type(5n) {
  margin: 0 0 20px 0;
}

.dataFileBG2 {
  text-align: center;

  i {
    margin-top: 50px;
  }

  p {
    margin: 60px 0 50px;
    color: #2f6d8c;
    color: #999;
  }

}



.video-info {
  display: flex;
  justify-content: space-between;

  .info-left {
    width: 100%;
    margin-bottom: 2rem;
    // box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);

    .hidden-item {
      border-bottom: none !important;
    }

    .intr-item {
      display: flex;
      line-height: 4rem;
      border-bottom: 1px solid #efefef;
      font-size: 1.2rem;
      color: #666666;

      .item-label {
        width: 8rem;
      }

      .item-content {
        display: flex;
        align-items: center;
        width: calc(100% - 8rem);
        line-height: 2rem;
      }
    }

    .el-tabs--border-card {
      border: none;
      -webkit-box-shadow: none;
      box-shadow: none;
    }

    :deep(.el-tab-pane) {
      min-height: 380px;
    }

    :deep(.el-tabs__content) {
      padding: 3rem;
      padding-top: 1rem;
    }

    :deep(.el-tabs__header) {
      user-select: none;
      background-color: #fff;
    }

    :deep(.el-tabs__item) {
      width: 14rem;
      padding: 0 3rem;
      border: 1px solid #ddd;
      border-bottom: none;
      text-align: center;

      &:hover {
        color: #e62125;
      }
    }

    :deep(.is-active) {
      border-bottom: none;
      color: #e62125;
      font-weight: 700;
      font-size: 1.2rem;
    }
  }

  .info-right {
    width: 25%;
    background: #ffffff;
    height: 260px;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    user-select: none;

    header {
      width: 100%;
      height: 3.2rem;
      display: flex;
      align-items: center;
      background: #2c2e3f;
      color: #fff;
      font-size: 1.2rem;

      img {
        margin: 0 1.3rem;
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    .file-content {
      height: calc(100% - 3.2rem);
      overflow: auto;

      .content-placeholder {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
        color: #999999;
      }

      .file-item {
        margin: 0.5rem;
        padding: 0.5rem 0.8rem;
        display: flex;
        height: 3rem;
        justify-content: space-between;
        align-items: center;
        font-size: 1.2rem;

        i {
          font-size: 1.5rem;
        }

        &:hover {
          background: #e9ecf3;
          cursor: pointer;
        }
      }
    }
  }
}

.copyright-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;

  .copyright-text {
    font-size: 14px;
    color: #000;
    font-weight: 500;
    margin-right: 10px;
  }

  .el-icon-info {
    transform: scale(1.5);
  }

}



// live-commont end
</style>
